import React from 'react';
import { Save, X } from 'lucide-react';

function PathwaySaveDialog({
  isOpen,
  title,
  error,
  isSaving,
  onTitleChange,
  onClose,
  onSave
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="pathway-save-dialog-overlay" role="presentation" onClick={onClose}>
      <form
        className="pathway-save-dialog"
        onSubmit={onSave}
        role="dialog"
        aria-modal="true"
        aria-labelledby="save-pathway-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="pathway-save-dialog-header">
          <div>
            <div className="section-label" id="save-pathway-title">Save Pathway</div>
            <p className="assistant-info">Choose a name for this saved pathway.</p>
          </div>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close save pathway dialog">
            <X size={14} />
          </button>
        </div>
        <label className="input-label" htmlFor="pathway-save-name">Pathway name</label>
        <input
          id="pathway-save-name"
          value={title}
          onChange={(event) => onTitleChange(event.target.value)}
          autoFocus
        />
        {error && <p className="participant-copy-status error">{error}</p>}
        <div className="pathway-save-dialog-actions">
          <button type="button" className="text-btn" onClick={onClose} disabled={isSaving}>
            Cancel
          </button>
          <button type="submit" className="btn-primary" disabled={isSaving}>
            <Save size={16} />
            {isSaving ? 'Saving...' : 'Save Pathway'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default PathwaySaveDialog;
